import script from "./GameTermsPurchaseMain.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTermsPurchaseMain.vue?vue&type=script&setup=true&lang=js"

import "./GameTermsPurchaseMain.vue?vue&type=style&index=0&id=0a1ee4d0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1ee4d0"]])

export default __exports__